module.exports = __webpack_public_path__ + "static/media/logo.a17a30a8.png";